import React, { useEffect, useState } from 'react';

function Referees() {
  const [referees, setReferees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pentru exemplu, preluăm arbitrii clubului 1
  const clubId = 1;

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');

    fetch(`https://www.fro.ro/api/referees/index.php?club_id=${clubId}`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setReferees(data.data);
        } else {
          setError('Eroare la încărcarea arbitrilor');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Eroare la conexiune');
        setLoading(false);
      });
  }, [clubId]);

  if (loading) return <p>Se încarcă arbitrii...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div style={{ maxWidth: 600, margin: 'auto', padding: 20 }}>
      <h2>Arbitri club</h2>
      {referees.length === 0 && <p>Nu există arbitri.</p>}
      <ul>
        {referees.map(referee => (
          <li key={referee.id} style={{ marginBottom: 15 }}>
            {referee.first_name} {referee.last_name} - Anul nașterii: {referee.birth_year}
            {referee.categorie ? ` - Categorie: ${referee.categorie}` : ''}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Referees;
